import { env } from 'src/configs/env'

export type displayDiscountTagAndEventProps = {
  discountPercentage?: number
  isAvailable?: boolean
}

type displayImageEventProps = {
  isAvailable: boolean
  originalPrice?: number
  discountPrice?: number
}

export const hasPromotionalEvent = (
  originalPrice?: number,
  discountPrice?: number
): boolean => originalPrice !== discountPrice

export const displayDiscountTagAndEvent = ({
  discountPercentage,
  isAvailable = undefined,
}: displayDiscountTagAndEventProps): boolean => {
  return (
    !!discountPercentage &&
    discountPercentage >= env.minimoPercentualDesconto &&
    !!isAvailable
  )
}

export const displayImageEvent = ({
  isAvailable,
  originalPrice,
  discountPrice,
}: displayImageEventProps) => {
  return isAvailable && hasPromotionalEvent(originalPrice, discountPrice)
}

export const displayPromotionalTag = (discountValue?: number): boolean =>
  !!discountValue && discountValue >= env.minimumDiscountPrice
